export default "__VITE_ASSET__CW04iae4__"